import { Button } from "@mui/material";
import { CustomNoRowsOverlayProps } from "ag-grid-react";
import MuiIcon from "../../../../../../../../../shared/styles/mui/helpers/mui-icon.helper";


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function ChildGridAddRowButtonOverlayComponent(props: CustomNoRowsOverlayProps & {
    onAddClick: () => void
}) {
    return (
        <div
            style={{
                position: "relative", // Ensure it is positioned relative to the grid
                zIndex: 10,          // High z-index to ensure it appears on top
                pointerEvents: "auto", // Allow the button to receive click events
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Button variant="contained" color="primary"
                startIcon={MuiIcon.ADD_CIRCLE()}
                endIcon={MuiIcon.COLUMNS()}
                onClick={props.onAddClick}
            >
                Add Pivot Child Column
            </Button>
        </div>
    );
};